import { createSlotRecipe } from './runtime';

const stateConfig = {"name":"state","slots":["root","glyph","title","body","action"],"defaultVariants":{"bare":false,"tone":"empty"},"variantMap":{"bare":["false","true"],"tone":["empty","error","info","noAccess"]}}

export const state = /* @__PURE__ */ createSlotRecipe(stateConfig)